import { toast } from 'react-toastify'

const refreshTokenURL = '/refreshToken'
const ACCESS_ERROR = 'Ocorreu um erro no acesso a rede, tente novamente mais tarde'

const buildUrl = (baseUrl, url, params) => {
  let fullURL = `${(baseUrl || '').replace(/\/$/, '')}${url}`
  if (params && Object.keys(params).length > 0) {
    const separator = fullURL.includes('?') ? '&' : '?'
    fullURL += separator + new URLSearchParams(params).toString()
  }
  return fullURL
}

const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem('refreshToken')
  const refreshResp = await request(refreshTokenURL, {
    method: 'POST',
    body: JSON.stringify({ refreshToken })
  })
  const { accessToken: newToken } = refreshResp.data.data[0]
  localStorage.setItem('accessToken', newToken)
}

const handleSessionExpired = () => {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
  const errorMessage = 'Sua sessão expirou. Você será redirecionado para o login'
  toast.error(errorMessage)
  setTimeout(() => { document.location.href = '/logoff' }, 3000)

  return {
    status: 200,
    data: {
      errors: [errorMessage],
      message: 'Erro com a identificação do usuário',
      success: false
    }
  }
}

const request = async (url, options = {}, isRetry = false) => {
  const { REACT_APP_API } = window?.env || {}
  const accessToken = localStorage.getItem('accessToken')

  const { params, headers: customHeaders, ...fetchOptions } = options

  const fullURL = buildUrl(REACT_APP_API, url, params)

  const hasBody = fetchOptions.body !== undefined
  const isFormData = fetchOptions.body instanceof FormData

  const headers = {
    ...(hasBody && !isFormData ? { 'Content-Type': 'application/json' } : {}),
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    ...customHeaders
  }

  let response
  try {
    response = await fetch(fullURL, { ...fetchOptions, headers })
  } catch {
    toast.error(ACCESS_ERROR)
    throw new Error(ACCESS_ERROR)
  }

  if (response.ok) {
    const data = await response.json().catch(() => null)
    return { data, status: response.status }
  }

  if (url !== refreshTokenURL) {
    if ([401, 403].includes(response.status) && !isRetry) {
      try {
        await refreshAccessToken()
        return request(url, options, true)
      } catch {
        return handleSessionExpired()
      }
    } else {
      const errorData = await response.json().catch(() => ({}))
      const message = errorData?.message
        ? JSON.stringify(errorData.message)
        : response.statusText
          ? `${response.statusText} - ${url}`
          : ACCESS_ERROR
      toast.error(message)
      throw new Error(message)
    }
  } else {
    throw new Error(`Refresh token failed: ${response.status}`)
  }
}

const api = {
  get: (url, config = {}) => request(url, { method: 'GET', ...config }),
  post: (url, data, config = {}) => {
    const body = data instanceof FormData ? data : JSON.stringify(data)
    return request(url, { method: 'POST', body, ...config })
  },
  put: (url, data, config = {}) => request(url, { method: 'PUT', body: JSON.stringify(data), ...config }),
  patch: (url, data, config = {}) => request(url, { method: 'PATCH', body: JSON.stringify(data), ...config }),
  delete: (url, config = {}) => request(url, { method: 'DELETE', ...config })
}

export default api
